import type { FC } from 'react'
import React from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Get a custom price quote`,
  description: `Customer Data Platform plans are designed to help your business achieve its customer activation use cases. Contact us for plan and add-on pricing.`,
  buttonTitle: `Request a quote`,
}

const GettingStarted: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Copy>
        <StyledCopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledCopyTextBase>
        <Content>
          <Button
            size="large"
            color="primary"
            variant="filled"
            tag="a"
            href={getAbsoluteUrl(`/demo/`, pageConfig)}
            onClick={() =>
              trackButtonClick({
                buttonText: copy.buttonTitle,
                targetUrl: `/demo/`,
                buttonId: `pricing-cdp-page-request-a-quote`,
              })
            }
          >
            {copy.buttonTitle}
          </Button>
        </Content>
      </Copy>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 80px;
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 0 20px;
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 80px 30px;
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
`

const Content = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  gap: 24px;
  justify-content: center;
`

export default GettingStarted
